import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredTrimmed(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (typeof value === 'string') {
      return value.trim().length === 0 ? { required: true } : null;
    }

    // fall back to normal required behaviour for non-strings
    return value == null ? { required: true } : null;
  };
}
